<template>
    <div class="player-list">
        <div class="table-cover" :class="{fullTable: openList}">
            <table>
                <thead>
                <tr class="title">
                    <th>Место</th>
                    <th>Никнейм</th>
                    <th>Кол-во</th>
                </tr>
                <tr class="your">
                    <th>{{playerPosition || "—"}}</th>
                    <th>{{$auth.user().user.user}}</th>
                    <th>{{playerCount}}</th>
                </tr>
                <tr v-if="!playerPosition">
                    <td class="no-stats full" colspan="3">
                        <span class="blue">Вас еще нет в топе.</span>&#32;
                        <span>{{topTask}}</span>
                    </td>
                </tr>
                <tr>
                    <td colspan="3" class="full">
                        <div class="line"></div>
                    </td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(player, index) of list">
                    <td>{{index + 1}}</td>
                    <td>{{player.nickname}}</td>
                    <td>{{player[keyVal] && player[keyVal].toLocaleString()}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="linker show-full-list dashed" @click="openList = !openList">
            {{openList ? 'Скрыть' : 'Показать еще'}}
        </div>
    </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import {TOP_TASKS} from "@/utils/CONST";

export default {
    name: "player_list",
    props: {
        list: {
            type: Array,
            require: true
        },
        keyVal: {
            type: String,
            require: true
        }
    },
    data: () => ({
        openList: false,
/*        stat: {
            "break": {"count": 1, "position": 11},
            "place": {"count": 2, "position": 12},
            "kills": {"count": 3, "position": false},
            "deaths": {"count": 4, "position": 14},
            "joins": {"count": 5, "position": false},
            "messages": {"count": 6, "position": 16},
            "playTime": {"count": 7, "position": 17}
        }*/
    }),
    computed: {
        playerPosition() {
            if (this.stat && this.stat[this.keyVal]) {
                return this.stat[this.keyVal].position;
            }
        },
        playerCount() {
            if (this.stat && this.stat[this.keyVal]) {
                return this.stat[this.keyVal].count;
            }
        },
        topTask(){
            return TOP_TASKS[this.keyVal];
        },
        ...mapState('cabinet', ['stat']),
    },
    methods: {
        ...mapActions('cabinet', ['getStat'])
    },
    created() {
        if (!this.stat) this.getStat()
    },
}
</script>

<style scoped lang="scss">
.player-list {
  position: relative;

  &::after {
    content: '';
    pointer-events: none;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: linear-gradient(180deg, rgba(14, 16, 20, 0) 0%, #0E1014 100%);
  }

  .show-full-list {
    position: absolute;
    z-index: 54;
    bottom: -24px;
    left: 50%;
    transform: translateX(-50%);
  }

  .table-cover {
    max-height: 750px;
    overflow: hidden;
    margin-bottom: 25px;

    &.fullTable {
      max-height: unset;
    }

    table {
      border-collapse: collapse;
      width: 100%;

      th, td {
        width: auto;
        text-align: start;

        &:first-child:not(.full) {
          padding-right: 30px;
          width: 50px;

          @include mobile {
            width: 45px;
            padding-right: 20px;
          }
        }

        &:last-child {
          text-align: end;
        }
      }

      thead {
        th {
          padding-bottom: 16px;
        }

        .title {
          font-weight: 600;
          font-size: 14px;
          line-height: 18px;
          letter-spacing: 0.12em;
          color: $text_gray;
          text-transform: uppercase;
        }

        .your th {
          font-weight: bold;
          font-size: 18px;
          line-height: 22px;
          color: white;
        }


        .no-stats {
          font-weight: normal;
          font-size: 16px;
          line-height: 19px;
          text-align: start;

          .blue {
            font-weight: 700;
            color: $blue;
          }
        }

        .line {
          margin: 20px 0;
        }

        @include mobile {
          .title {
            font-size: 12px;
            line-height: 18px;
          }

          .your th {
            font-size: 16px;
            line-height: 19px;
          }
          .no-stats {
            font-size: 14px;
          }
          .line {
            margin: 12px 0;
          }
        }
      }

      tbody {
        color: white;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;

        @include mobile {
          font-size: 16px;
          line-height: 19px;
        }

        td {
          padding: 10px 0;
        }

        td:first-child {
          color: $text_gray;
        }

        tr:nth-child(1), tr:nth-child(2), tr:nth-child(3) {
          font-weight: 700;
        }

        tr:nth-child(1) {
          td:nth-child(1), td:nth-child(2) {
            color: $orange;
          }
        }

        tr:nth-child(2) {
          td:nth-child(1), td:nth-child(2) {
            color: $blue;
          }
        }

        tr:nth-child(3) {
          td:nth-child(1), td:nth-child(2) {
            color: $green;
          }
        }
      }
    }
  }
}
</style>
